/**
 * Created by Mike Naughton on 6/22/17.
 *
 * Locks down page navigation until successfully bootstrapped
 */

import ModalView from "core/views/ModalView";
import $ from "jquery";
(function () {
  var modalView;
  var destination = location.pathname;
  var _once = function (func) {
    var times = 2;
    var memo;

    return function () {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }

      if (times <= 1) func = null;

      return memo;
    };
  };

  var boundFunction = _once(function (event) {
    var href = event.target.getAttribute("href");
    var modalClass = "app-boot";
    var $el = $(".app-boot");

    if ($el.length <= 0) {
      $el = null;
    }

    event.preventDefault();
    destination = href;
    modalView = new ModalView({
      title: "Loading",
      locked: true,
      modalClass: modalClass,
      el: $el,
    });
    modalView.render();
    modalView.inProgress(true);
    modalView.show();
  });
  var clickHandler = function (evt) {
    if (
      evt.target.tagName.toLowerCase() == "a" &&
      evt.target.getAttribute("href").indexOf("/") === 0
    ) {
      // the '/' meaning it's to this site
      boundFunction(evt);
    }
  };

  document.addEventListener("click", clickHandler);

  window.hideLoad = function () {
    if (modalView) modalView.hide();
    document.removeEventListener("click", clickHandler);
    return {
      path: destination,
      view: modalView,
    };
  };
})();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/lock-navigation.js
// module id = 976
// module chunks = 3